export class Login {
    username: string = null;
    password: string = null;

    public constructor(init?: Partial<Login>) {
        Object.assign(this, init);
    }
}

export class LoginResult {
    Message: string = null;
    status: string = null;

    constructor() { }
}
